import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import Loading from "../../common/Loading";
import { CONTRACTS_BY_TYPE_COLUMNS } from "./columns";

const ContractsByTypeList = ({
  data,
  loading,
  pages,
  page,
  sorted,
  pageSize,
  onRowClick = () => {},
  onPageChange,
  onSortedChange,
  onPageSizeChange,
  handleExport
}) => {
  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  return data && data.length ? (
    <div className="content-wrapper">
      <div className="table-header-wrapper">
        <button className="btn btn-success" onClick={handleExport}>
          Export
        </button>
      </div>

      <ReactTable
        className="-highlight"
        data={data}
        columns={CONTRACTS_BY_TYPE_COLUMNS}
        pages={pages}
        manual
        sorted={sorted}
        pageSize={Math.min(data.length, pageSize)}
        page={page}
        onPageChange={onPageChange}
        showPagination
        onSortedChange={onSortedChange}
        onPageSizeChange={onPageSizeChange}
        defaultSorted={[{ id: "customerName", desc: false }]}
        getTrProps={(state, rowInfo) => ({
          onClick: () => onRowClick(rowInfo)
        })}
      />
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};

ContractsByTypeList.propTypes = {
  data: PropTypes.array,
  page: PropTypes.number,
  pages: PropTypes.number,
  loading: PropTypes.bool,
  onRowClick: PropTypes.func,
  onPageChange: PropTypes.func,
  onSortedChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  pageSize: PropTypes.number,
  sorted: PropTypes.array,
  handleExport: PropTypes.func
};

export default ContractsByTypeList;
